import { jsx as _jsx } from "preact/jsx-runtime";
import { render } from 'preact';
class InitWidget {
    element;
    widgetName;
    constructor(element, module) {
        this.element = element;
        this.widgetName = module;
        this.init();
    }
    init() {
        import((`./${this.widgetName}/index.ts`)).then(({ default: WidgetComponent }) => {
            render((_jsx(WidgetComponent, { dataset: this.element.dataset })), this.element);
            window.dispatchEvent(new CustomEvent('widget.loaded', {
                detail: {
                    element: this.element,
                    widget: this.widgetName,
                },
            }));
        });
    }
}
export default InitWidget;
